/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Types from '../../generated/types'

import { gql } from '@apollo/client'
import { FieldFragmentDoc } from '../../ui-legacy/Field/Field.generated'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type FormFragment = {
  __typename?: 'Form'
  id: string
  title?: string | null
  caption?: string | null
  description?: string | null
  submitButtonText?: string | null
  showActions?: boolean | null
  denseFormat?: boolean | null
  fields?: Array<
    | {
        __typename: 'BooleanField'
        id: string
        label?: string | null
        description?: string | null
        information?: string | null
        state?: boolean | null
        localEdited?: boolean | null
        localState?: boolean | null
      }
    | {
        __typename: 'DateField'
        id: string
        label?: string | null
        description?: string | null
        information?: string | null
        date?: any | null
        localEdited?: boolean | null
        localDate?: string | null
      }
    | {
        __typename: 'DateTimeField'
        id: string
        label?: string | null
        description?: string | null
        information?: string | null
        dateTime?: any | null
        localEdited?: boolean | null
        localDateTime?: string | null
      }
    | {
        __typename: 'DownloadFileField'
        id: string
        label?: string | null
        description?: string | null
        information?: string | null
        selection?: {
          __typename?: 'SelectField'
          style?: Types.SelectStyle | null
          localEdited?: boolean | null
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
          selection?: { __typename?: 'SelectOption'; label: string; value: string } | null
          localSelection?: { __typename?: 'SelectOption'; label: string; value: string } | null
        } | null
      }
    | {
        __typename: 'MultiSelectField'
        id: string
        label?: string | null
        description?: string | null
        information?: string | null
        style?: Types.SelectStyle | null
        localEdited?: boolean | null
        options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
        selections?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
        localSelections?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
      }
    | {
        __typename: 'NumberField'
        id: string
        label?: string | null
        description?: string | null
        information?: string | null
        value?: number | null
        localEdited?: boolean | null
        localValue?: number | null
      }
    | {
        __typename: 'NumberRangeField'
        id: string
        label?: string | null
        description?: string | null
        information?: string | null
      }
    | {
        __typename: 'SelectField'
        id: string
        label?: string | null
        description?: string | null
        information?: string | null
        style?: Types.SelectStyle | null
        localEdited?: boolean | null
        options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
        selection?: { __typename?: 'SelectOption'; label: string; value: string } | null
        localSelection?: { __typename?: 'SelectOption'; label: string; value: string } | null
      }
    | {
        __typename: 'TextField'
        id: string
        label?: string | null
        description?: string | null
        information?: string | null
        text?: string | null
        localEdited?: boolean | null
        localText?: string | null
      }
    | {
        __typename: 'UploadFileField'
        id: string
        label?: string | null
        description?: string | null
        information?: string | null
        overrideAppId?: string | null
        templateId?: string | null
        entityId?: string | null
      }
  > | null
}

export type ContentIdsFragment = {
  __typename?: 'ContentIds'
  apps?: Array<string> | null
  charts?: Array<string> | null
  forms?: Array<string> | null
  metrics?: Array<string> | null
  pages?: Array<string> | null
  tables?: Array<string> | null
}

export type SubmitFormMutationVariables = Types.Exact<{
  appId: Types.Scalars['ID']
  formId: Types.Scalars['ID']
  projectId?: Types.InputMaybe<Types.Scalars['Int']>
  filters: Array<Types.FieldInput> | Types.FieldInput
  fields: Array<Types.FieldInput> | Types.FieldInput
  extraInputs: Array<Types.QueryInput> | Types.QueryInput
}>

export type SubmitFormMutation = {
  __typename?: 'Mutation'
  submitForm: {
    __typename?: 'SubmitFormEvent'
    ok: boolean
    message?: string | null
    contentToRefresh?: {
      __typename?: 'ContentIds'
      apps?: Array<string> | null
      charts?: Array<string> | null
      forms?: Array<string> | null
      metrics?: Array<string> | null
      pages?: Array<string> | null
      tables?: Array<string> | null
    } | null
  }
}

export type FormQueryVariables = Types.Exact<{
  appId: Types.Scalars['ID']
  formId: Types.Scalars['ID']
  projectId?: Types.InputMaybe<Types.Scalars['Int']>
  filters: Array<Types.FieldInput> | Types.FieldInput
  extraInputs?: Types.InputMaybe<Array<Types.QueryInput> | Types.QueryInput>
}>

export type FormQuery = {
  __typename?: 'Query'
  app?: {
    __typename?: 'App'
    id: string
    formById?: {
      __typename?: 'Form'
      id: string
      title?: string | null
      caption?: string | null
      description?: string | null
      submitButtonText?: string | null
      showActions?: boolean | null
      denseFormat?: boolean | null
      fields?: Array<
        | {
            __typename: 'BooleanField'
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
            state?: boolean | null
            localEdited?: boolean | null
            localState?: boolean | null
          }
        | {
            __typename: 'DateField'
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
            date?: any | null
            localEdited?: boolean | null
            localDate?: string | null
          }
        | {
            __typename: 'DateTimeField'
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
            dateTime?: any | null
            localEdited?: boolean | null
            localDateTime?: string | null
          }
        | {
            __typename: 'DownloadFileField'
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
            selection?: {
              __typename?: 'SelectField'
              style?: Types.SelectStyle | null
              localEdited?: boolean | null
              id: string
              label?: string | null
              description?: string | null
              information?: string | null
              options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
              selection?: { __typename?: 'SelectOption'; label: string; value: string } | null
              localSelection?: { __typename?: 'SelectOption'; label: string; value: string } | null
            } | null
          }
        | {
            __typename: 'MultiSelectField'
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
            style?: Types.SelectStyle | null
            localEdited?: boolean | null
            options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
            selections?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
            localSelections?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
          }
        | {
            __typename: 'NumberField'
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
            value?: number | null
            localEdited?: boolean | null
            localValue?: number | null
          }
        | {
            __typename: 'NumberRangeField'
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
          }
        | {
            __typename: 'SelectField'
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
            style?: Types.SelectStyle | null
            localEdited?: boolean | null
            options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
            selection?: { __typename?: 'SelectOption'; label: string; value: string } | null
            localSelection?: { __typename?: 'SelectOption'; label: string; value: string } | null
          }
        | {
            __typename: 'TextField'
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
            text?: string | null
            localEdited?: boolean | null
            localText?: string | null
          }
        | {
            __typename: 'UploadFileField'
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
            overrideAppId?: string | null
            templateId?: string | null
            entityId?: string | null
          }
      > | null
    } | null
  } | null
}

export const FormFragmentDoc = gql`
  fragment Form on Form {
    id
    title
    caption
    description
    submitButtonText
    showActions
    fields {
      ...Field
    }
    denseFormat
  }
  ${FieldFragmentDoc}
`
export const ContentIdsFragmentDoc = gql`
  fragment ContentIds on ContentIds {
    apps
    charts
    forms
    metrics
    pages
    tables
  }
`
export const SubmitFormDocument = gql`
  mutation SubmitForm(
    $appId: ID!
    $formId: ID!
    $projectId: Int
    $filters: [FieldInput!]!
    $fields: [FieldInput!]!
    $extraInputs: [QueryInput!]!
  ) {
    submitForm(
      input: { id: $formId, appId: $appId, projectId: $projectId, filters: $filters, fields: $fields }
      extraInputs: $extraInputs
    ) {
      ok
      contentToRefresh {
        ...ContentIds
      }
      message
    }
  }
  ${ContentIdsFragmentDoc}
`
export type SubmitFormMutationFn = Apollo.MutationFunction<SubmitFormMutation, SubmitFormMutationVariables>

/**
 * __useSubmitFormMutation__
 *
 * To run a mutation, you first call `useSubmitFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFormMutation, { data, loading, error }] = useSubmitFormMutation({
 *   variables: {
 *      appId: // value for 'appId'
 *      formId: // value for 'formId'
 *      projectId: // value for 'projectId'
 *      filters: // value for 'filters'
 *      fields: // value for 'fields'
 *      extraInputs: // value for 'extraInputs'
 *   },
 * });
 */
export function useSubmitFormMutation(
  baseOptions?: Apollo.MutationHookOptions<SubmitFormMutation, SubmitFormMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SubmitFormMutation, SubmitFormMutationVariables>(SubmitFormDocument, options)
}
export type SubmitFormMutationHookResult = ReturnType<typeof useSubmitFormMutation>
export type SubmitFormMutationResult = Apollo.MutationResult<SubmitFormMutation>
export type SubmitFormMutationOptions = Apollo.BaseMutationOptions<SubmitFormMutation, SubmitFormMutationVariables>
export const FormDocument = gql`
  query Form($appId: ID!, $formId: ID!, $projectId: Int, $filters: [FieldInput!]!, $extraInputs: [QueryInput!]) {
    app(id: $appId, projectId: $projectId, filters: $filters, extraInputs: $extraInputs) {
      id
      formById(id: $formId) {
        ...Form
      }
    }
  }
  ${FormFragmentDoc}
`

/**
 * __useFormQuery__
 *
 * To run a query within a React component, call `useFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormQuery({
 *   variables: {
 *      appId: // value for 'appId'
 *      formId: // value for 'formId'
 *      projectId: // value for 'projectId'
 *      filters: // value for 'filters'
 *      extraInputs: // value for 'extraInputs'
 *   },
 * });
 */
export function useFormQuery(baseOptions: Apollo.QueryHookOptions<FormQuery, FormQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FormQuery, FormQueryVariables>(FormDocument, options)
}
export function useFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormQuery, FormQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FormQuery, FormQueryVariables>(FormDocument, options)
}
export type FormQueryHookResult = ReturnType<typeof useFormQuery>
export type FormLazyQueryHookResult = ReturnType<typeof useFormLazyQuery>
export type FormQueryResult = Apollo.QueryResult<FormQuery, FormQueryVariables>
